
<ng-container *ngIf="(serviceAutomationDetails$ | async) as serviceAutomationDetails">

    <div class="" *ngIf="serviceAutomationDetails.length === 0; else hasAutomation">
      <div class="flex justify-end">
       
      </div>
      <div class="bg-white col-md-12 mt-4 mx-auto rounded-md p-4 text-center font-medium text-muted move-left">
        {{ 'no_basic_details' | translate }}
      </div>
    </div>
  
    <ng-template #hasAutomation>
      <div class="m-2 row flex justify-center" *ngIf="serviceAutomationDetails[0] as serviceAutomationDetail">
        <div class="col-md-12 row  bg-white rounded-md">
          <div class="col-md-6 d-flex flex-column move-left">
            <div class="text-bold text-primary-500">{{ 'is_service_automated' | translate }}</div>
            <div class="text-bold !text-muted my-2 lbb-dotted pb-1">
              {{ serviceAutomationDetail.serviceIsAutomated }}
            </div>
          </div>
  
          <ng-container *ngIf="serviceAutomationDetail.serviceIsAutomated === 'YES'">
            <div class="col-md-6 d-flex flex-column move-left">
              <div class="text-bold text-primary-500">{{ 'system_usage' | translate }}</div>
              <div class="text-bold !text-muted my-2 lbb-dotted pb-1">
                {{ serviceAutomationDetail.serviceAutomatedPart }}
              </div>
            </div>
  
  
            <div class="font-medium text-muted mt-3">
              {{ 'add_automation_details' | translate }}
            </div>
            <div class="py-2 flex col-md-6"
                 *ngFor="let provision of serviceAutomationDetail.serviceProvisions; let i = index">
              <span class="p-2">
                {{ i + 1 }}.
              </span>
              <div class="border rounded-md bg-[#F8F9FA] w-full ">
                <div class="flex">
                  <div class="gradient-header move-left">
                    {{ provision.serviceProvisionMeans === 'MobileApp' ? 'Mobile App' : provision.serviceProvisionMeans }}
                  </div>
                </div>
                <div class="row p-2">
                  <div class="col-md-6 d-flex flex-column move-left">
                    <div class="text-bold text-primary-500">{{ 'service_system_name' | translate }}</div>
                    <div class="text-bold !text-muted my-2 lbb-dotted pb-1">
                      {{ provision.serviceSystemName }}
                    </div>
                  </div>
                  <div class="col-md-6 d-flex flex-column move-left">
                    <div class="text-bold text-primary-500">{{ 'access_link' | translate }}</div>
                    <div class="text-bold !text-muted my-2 lbb-dotted pb-1">
                      {{ provision.serviceReachLink }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
  
            <div class="font-medium text-muted mt-3">
              {{ 'service_foundation' | translate }}
            </div>
            <div class="py-2 flex col-md-6"
                 *ngFor="let existanceSource of serviceAutomationDetail.serviceExistenceSources; let i = index">
              <span class="p-2">
                {{ i + 1 }}.
              </span>
              <div class="border rounded-md bg-[#F8F9FA] w-full ">
                <div class="flex">
                  <div class="gradient-header move-left">
                   
                  </div>
                </div>
                <div class="row p-2">
                  <div class="col-md-12 d-flex flex-column move-left">
                    <div class="text-bold text-primary-500">{{ 'source_url' | translate }}</div>
                    <div class="text-bold !text-muted my-2 lbb-dotted pb-1">
                      {{ existanceSource.serviceExistenceSourceLink }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
  
        </div>
       
      </div>
    </ng-template>
  
  </ng-container>
